/*
 * @Description:
 * @Version:
 * @Autor: yqf
 * @Date: 2022-08-05 17:35:33
 * @LastEditors: yqf
 * @LastEditTime: 2022-11-16 17:40:29
 * @FilePath: \h5-lcjc-formula\src\utils\category\ObGyn.js
 */
/** 产科学 */

/** 对应的标题 */
const categoryMap = {
  SilvermanAnderson: 'Silverman-Anderson',
  PainScale: '表情疼痛量表',
  APGAR: 'Apgar',
  Bishop: 'Bishop评分',
  Malinas: 'Malinas 评分',
  PregnancyWeek: '孕周估算',
  LMP: '预产期计算（LMP）',
  SI: '休克指数',
  PremenstrualDysphoricDisorderDiagnosticCriteria:'经前焦虑障碍PMDD诊断标准',
  Pregnancy_Associated_Plasma_Protein_A:'妊娠相关血浆蛋白A（PAPP-A）',
  Follicle_Stimulating_Hormone:"卵泡刺激素（FSH）",
  Soluble_Fms_like_Tyrosine_Kinase_1:"可溶性Fms样酪氨酸激酶1（sFlt-1）",
  Progesterone:"黄体酮"
  
}
/** 对应的描述 */
const categoryDescMap = {
  PainScale: '用于评估患者疼痛程度',
  APGAR: '新生儿初始评估',
  Bishop: '评估孕妇宫颈成熟度',
  Malinas: '是否即将分娩？',
  PregnancyWeek: '孕周和预产期',
  LMP: '末次月经时间计算预产期',
  SI: '用休克指数（SI）计算产后出血量'
}
/** 没有公式描述的页面 */
const categoryNotInfoMap = {
  PregnancyWeek: 'PregnancyWeek',
}
export default {
  categoryMap,
  categoryDescMap,
  categoryNotInfoMap
}



// WEBPACK FOOTER //
// ./src/utils/category/ObGyn.js